module.exports = __webpack_public_path__ + "static/media/SISTA.7e2259e9.svg";